
import { i18nText } from '@/locales';
import { PartnerRequestType, PartnerResponseType } from "@/entity/common/partner.types";

export interface transferData {
    all: string
    category: [] | any
    id: [] | any
}

export interface transferForm {
    salon_id: number | null
    services: transferData
    products: transferData
    loyalty: transferData
}

class Partner implements PartnerRequestType {
    id: number | null;
    email: string;
    name: string;
    phone: string;
    social_network: string;
    constructor() {
        this.id = null;
        this.email = "";
        this.name = "";
        this.phone = "";
        this.social_network = "";
    }
}

export class GroupFormData {
    public name: string;
    constructor() {
        this.name = "";
    }
}

class BaseStudioForm {
    id: number | null;
    active: boolean | null;
    salon_name: string;
    city_id: number | null;
    //partner: PartnerRequestType;
    partner_name: string;
    partner_phone: string;
    partner_email: string;
    partner_social_network: string;

    opening_date: string;
    work_time_from: string | null;
    work_time_to: string | null;
    phone: string | null;
    address: string;
    social_network_link: string;
    escort_manager_id: number | null;
    salon_group_id: number | null;
    conclusion_contract_date: string;
    currency_id: number | null;
    legal_entity_name: string;
    name: string;

    legal_address: string;
    INN: string;
    KPP: string;
    RCBIC: string;
    bank_name: string;
    correspondent_account: string;
    checking_account: string;

    transfer: transferForm

    constructor() {
        this.id = null;
        this.active = null;
        this.salon_name = "";
        this.city_id = null;
        this.name = "";
        this.phone = "";

        this.partner_name = "";
        this.partner_phone = "";
        this.partner_email = "";
        this.partner_social_network = "";
        this.legal_entity_name = "";
        this.legal_address = "";
        this.INN = "";
        this.KPP = "";
        this.RCBIC = "";
        this.bank_name = "";
        this.correspondent_account = "";
        this.checking_account = "";

        this.opening_date = "";
        this.work_time_from = "";
        this.work_time_to = "";
        this.address = "";
        this.social_network_link = "";
        this.escort_manager_id = null;
        this.salon_group_id = null;
        this.conclusion_contract_date = "";
        this.currency_id = null;
        this.legal_entity_name = "";

        this.transfer = {
            salon_id: null,
            services: {
                all: '',
                category: [],
                id: []
            },
            products: {
                all: '',
                category: [],
                id: []
            },
            loyalty: {
                all: '',
                category: [],
                id: []
            }
        }
    }
}

export class StudioFormDataValid extends BaseStudioForm {
    legal_entity_data_id: number | null;
    legal_entity_data_name: string;
    legal_entity_data_legal_address: string;
    legal_entity_data_actual_address: string;
    legal_entity_data_INN: string;
    legal_entity_data_KPP: string;

    account_id: number | null;
    account_RCBIC: string;
    account_bank_name: string;
    account_correspondent_account: string;
    account_checking_account: string;

    constructor() {
        super();

        this.legal_entity_data_id = null;
        this.legal_entity_data_name = "";
        this.legal_entity_data_legal_address = "";
        this.legal_entity_data_actual_address = "";
        this.legal_entity_data_INN = "";
        this.legal_entity_data_KPP = "";
        this.account_id = null;
        this.account_RCBIC = "";
        this.account_bank_name = "";
        this.account_correspondent_account = "";
        this.account_checking_account = "";
    }
}
export class StudioFormData extends BaseStudioForm {
    partner: PartnerRequestType;
    constructor() {
        super();
        this.partner = new Partner();
    }
}

export const FormRules = {
    active: [{ required: true, message: i18nText("Укажите активность"), trigger: "change" }],
    salon_name: [{ required: true, message: i18nText("Введите наименование студии"), trigger: "change" }],
    phone: [{ required: true, message: i18nText("Введите номер телефона студии"), trigger: "change" }],
    city_id: [{ required: true, message: i18nText("Введите город"), trigger: "change" }],
    currency_id: [{ required: true, message: i18nText("Введите валюту"), trigger: "change" }],
    salon_group_id: [{ required: true, message: i18nText("Укажите группу"), trigger: "change" }],
    partner_name: [{ required: true, message: i18nText("Введите корректное ФИО партнера"), trigger: "change" }],
    partner_email: [{ required: true, message: i18nText("Введите корректный email партнера"), trigger: "change" }],
    partner_phone: [{ required: true, message: i18nText("Введите корректный телефон партнера"), trigger: "change" }],
    partner_social_network: [{ required: true, message: i18nText("Введите ссылку на личные соц.сети"), trigger: "change" }],
    conclusion_contract_date: [{ required: true, message: i18nText("Укажите дату заключения договора"), trigger: "change" }],
    legal_entity_name: [{ required: true, message: i18nText("Введите название юр.лица"), trigger: "change" }],
    // legal_entity_data_legal_address: [{ required: true, message: "Введите юр.адрес", trigger: "change" }],
    // legal_entity_data_INN: [{ required: true, message: "Введите ИНН", trigger: "change" }],
    // legal_entity_data_KPP: [{ required: true, message: "Введите КПП", trigger: "change" }],
    // account_RCBIC: [{ required: true, message: "Введите БИК", trigger: "change" }],
    // account_bank_name: [{ required: true, message: "Введите название банка", trigger: "change" }],
    // account_correspondent_account: [{ required: true, message: "Введите корр.счет", trigger: "change" }],
    // account_checking_account: [{ required: true, message: "Введите расчетный счет", trigger: "change" }],
    address: [{ required: true, message: i18nText("Введите адрес"), trigger: "change" }],
};

// export const FormGroupRules = {
    // name: [{ required: true, message: "Пожалуйста укажите группу", trigger: "change" }],
// };

